<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("pilates members") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column is-four-fifths">
        <div class="field">
          <label class="label">{{
            $t("minimum number of current hours")
          }}</label>
          <div class="control">
            <input
              class="input"
              type="number"
              v-model="meta.min_hours"
              placeholder="0"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="is-pulled-right">
        <div class="is-primary button" @click="download_excel">
          <span class="icon"><i class="fa fa-download"></i></span>
          <span>{{ $t("download excel") }}</span>
        </div>
      </div>
      <div class="title is-5">{{ $t("pilates members") }}</div>

      <div>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("number of hours") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(itm, spidx) in members" :key="spidx">
              <td>{{ itm.name }}</td>
              <td>{{ itm.remaining_hours }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  post,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_date,
  format_time,
  format_currency,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { groupBy } from "lodash";
import { size } from "lodash";
import XLSX from "xlsx/dist/xlsx.full.min.js";

export default {
  name: "PilatesMembersReport",
  components: { GenericTable, GenericCalendar, GenericDropdown },
  data() {
    let v = this;
    return {
      members: [],
      meta: {
        min_hours: 1,
      },
    };
  },
  computed: {},
  methods: {
    format_date_time,
    format_date,
    format_time,
    format_currency,
    query() {
      let v = this;
      let data = {
        args: v.meta,
        report_uuid: v.$route.params.id,
        method: "qq",
      };
      post("/report/query", data)
        .then((r) => {
          v.members = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    download_excel() {
      let v = this;
      let data = v.members.map((itm) => {
        return {
          [v.$t("name")]: itm.name,
          [v.$t("number of hours")]: itm.remaining_hours,
        };
      });
      let ws = XLSX.utils.json_to_sheet(data);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `pilates_members_${Date.now()}.xls`);
    },
  },
  mounted() {},
};
</script>

<style>
/* Add Bulma styles here */
</style>
